import type en from './en'

/**
 * Recursively optional mirror of the English namespace, so Spanish can be
 * filled in incrementally while `fallbackLng: 'en'` covers the gaps.
 */
export type PartialTranslations<T> = {
  [K in keyof T]?: T[K] extends string ? string : PartialTranslations<T[K]>
}

/**
 * Shared `common` i18next namespace — Spanish.
 *
 * Not yet translated: both apps ship English-only today (the existing mobile
 * `es` resources are placeholder stubs). Keys added here must exist in `en.ts`.
 */
const es: PartialTranslations<typeof en> = {}

export default es
